import React, { useState } from "react";
import { Button } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import "../../CSS/CrownCss/CrownSu_Depoları.css";

let state_2 = [
  {
    "KAZAN DAİRESİ SU BASKIN İZLEMESİ ": [
      { text: "ALARM 1", tagId: "103", class: "su-baskin" },
      { text: "ALARM 2", tagId: "104", class: "su-baskin" },
    ],
  },
  {
    "DEPO 1": [{ text: "Depo_1", tagId: "62" }],
  },
];

const CSuDepoları = () => {
  const [depo1, Set_depo1] = useState([
    { tagId: "103", tagValue: "ALARM 1" },
    { tagId: "104", tagValue: "ALARM 2" },
  ]);

  const [state, Setstate] = useState(state_2);

  const history = useHistory();

  const close_pop_up = (e) => {
    e.preventDefault();
    document
      .querySelector(".show_external_trend")
      .classList.toggle("show_external_trend_active");
  };

  return (
    <>
      <div className="show_pop_up show_external_trend">
        <i
          onClick={close_pop_up}
          style={{ position: "relative", left: "50%" }}
          className="fa fa-times close_tag_pop_up"
        ></i>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
          className="top_flex"
        >
          <p>
            {" "}
            TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
          </p>
          <p>
            {" "}
            TagName:{" "}
            <span className="pop_up_x pop_up_external show_tagName"></span>
          </p>
        </div>
      </div>
      <section
        style={{ backgroundColor: "rgb(240,240,240)" }}
        className="water_storage"
      >
        <Link to="/">
          <Button
            style={{
              position: "absolute",
              color: "black",
              top: "12%",
              left: "18%",
              zIndex: 9999999,
              borderRadius: "15px",
              backgroundColor: "#fff",
              border: "3px solid rgba(238, 200, 108, 0.99)",
              fontWeight: 600,
            }}
            className="movebuttons"
            variant="contained"
          >
            Geri
          </Button>
        </Link>
        <div className="bottom_pumps">
          {state.map((item, index) => {
            if (index < 1) {
              var title = [];
              var obj_ = [];
              Object.entries(item).forEach((a) => {
                title.push(a[0]);
                obj_.push(a[1]);
              });

              return (
                <div style={{ backgroundColor: "white" }} className="rows">
                  <div className="left">
                    <div></div>
                    <div className="lefttitle">{title[0]}</div>
                  </div>
                  <div className="right">
                    <div className="right_top">
                      {obj_[0].map((x, index) => {
                        if (x.text !== "Depo_1") {
                          const className =
                            x.text === ""
                              ? "pumpsdisplayNone"
                              : `${x.class} righttop`;
                          return (
                            <div className={x.class + " " + className}>
                              {x.text !== "" ? x.text : ""}
                            </div>
                          );
                        }
                      })}
                    </div>
                    <div className="right_bottom">
                      {obj_[0].map((x, index) => {
                        if (x.text !== "Depo_1") {
                          var last_değer = "NORMAL";
                          if (x.text.includes("Alarm")) {
                            last_değer = "ALARM";
                          }

                          return (
                            <div
                              style={
                                last_değer === "ALARM"
                                  ? { backgroundColor: "red", color: "white" }
                                  : {}
                              }
                              id={"pumps_gösterge_değerler_box"}
                            >
                              {last_değer}
                            </div>
                          );
                        }
                      })}
                    </div>
                  </div>
                </div>
              );
            }
          })}
        </div>
        <div className="crown-tanklar" style={{ display: "flex" }}>
          {" "}
          <div
            style={{
              alignItems: "center",
              display: "flex",
              flexDirection: "row-reverse",
              justifyContent: "center",
            }}
            id="jdx56_id9"
          >
            <div className="progress-container">
              <span className="progress-label">Tank Seviyesi</span>
              <div
                onContextMenu={(e) => {
                  e.preventDefault();
                  const { clientX, clientY } = e;
                  var tagName = "Tank Seviyesi";
                  var popup = document.querySelector(".show_external_trend");
                  document
                    .querySelector(".show_external_trend")
                    .classList.toggle("show_external_trend_active");
                  document.querySelector(".show_tagId").innerHTML = "62";
                  document.querySelector(".show_tagName").innerHTML = tagName;

                  const popupRect = popup.getBoundingClientRect();
                  const viewportWidth = window.innerWidth;
                  const viewportHeight = window.innerHeight;

                  let newX = clientX;
                  let newY = clientY;

                  if (newX + popupRect.width > viewportWidth) {
                    newX = viewportWidth - popupRect.width;
                  }

                  if (newY + popupRect.height > viewportHeight) {
                    newY = viewportHeight - popupRect.height;
                  }

                  if (newX < 0) {
                    newX = 0;
                  }

                  if (newY < 0) {
                    newY = 0;
                  }

                  popup.style.left = `${newX}px`;
                  popup.style.top = `${newY}px`;
                }}
                className="progress vertical"
              >
                <div
                  className={`progress-bar ${30 < 50 ? "red" : "yellow"}`}
                  style={{ height: `70%` }}
                ></div>
              </div>
              <span
                style={{
                  position: "relative",
                  fontWeight: "600",
                  fontSize: "larger",
                  color: "rgb(50,50,50)",
                  bottom: "10px",
                  width: "100px",
                  height: "30px",
                  textAlign: "center",
                }}
              >
                70 %
              </span>
            </div>
          </div>
          <div
            style={{
              alignItems: "center",
              display: "flex",
              flexDirection: "row-reverse",
              justifyContent: "center",
            }}
            id="jdx56_id9"
          >
            <div className="progress-container">
              <span className="progress-label">Tank Seviyesi</span>
              <div
                onContextMenu={(e) => {
                  e.preventDefault();
                  const { clientX, clientY } = e;
                  var tagName = "Tank Seviyesi";
                  var popup = document.querySelector(".show_external_trend");
                  document
                    .querySelector(".show_external_trend")
                    .classList.toggle("show_external_trend_active");
                  document.querySelector(".show_tagId").innerHTML = "62";
                  document.querySelector(".show_tagName").innerHTML = tagName;

                  const popupRect = popup.getBoundingClientRect();
                  const viewportWidth = window.innerWidth;
                  const viewportHeight = window.innerHeight;

                  let newX = clientX;
                  let newY = clientY;

                  if (newX + popupRect.width > viewportWidth) {
                    newX = viewportWidth - popupRect.width;
                  }

                  if (newY + popupRect.height > viewportHeight) {
                    newY = viewportHeight - popupRect.height;
                  }

                  if (newX < 0) {
                    newX = 0;
                  }

                  if (newY < 0) {
                    newY = 0;
                  }

                  popup.style.left = `${newX}px`;
                  popup.style.top = `${newY}px`;
                }}
                className="progress vertical"
              >
                <div
                  className={`progress-bar ${30 < 50 ? "red" : "yellow"}`}
                  style={{ height: `30%` }}
                ></div>
              </div>
              <span
                style={{
                  position: "relative",
                  fontWeight: "600",
                  fontSize: "larger",
                  color: "rgb(50,50,50)",
                  bottom: "10px",
                  width: "100px",
                  height: "30px",
                  textAlign: "center",
                }}
              >
                30 %
              </span>
            </div>
          </div>{" "}
        </div>
      </section>
    </>
  );
};

export default CSuDepoları;
